<template>
  <div class="container">
    <h2 v-if="!IsNew">Editing Favorite Set {{favSetID}}</h2>
    <h2 v-if="IsNew">New Favorite Set</h2>

    <form @submit.prevent="Update">
      <div class="form-group">
        <label for="description">Description</label>
        <input
          v-model="FavSet.Description"
          type="text"
          class="form-control"
          id="description"
          name="description"
          placeholder="Description"
        />
      </div>

      <div>
        Selected:
        <p>
          <span v-for="(item, idx) in Selected" :key="item.Channel.Number">
            <span v-if="idx != 0">, {{""}}</span>
            <router-link
              :to="{name:'masterdetailselected', params:{chcode: item.Channel.Number}}"
            >{{item.Channel.Name}}</router-link>
          </span>
        </p>
      </div>

      <div>
        <button @click="SelectAll()" type="button" class="btn btn-info">S e l e c t All</button>
        <button @click="DeselectAll()" type="button" class="btn btn-info">Deselect All</button>
      </div>

      <br />

      <div v-for="item in Selections" :key="item.Channel.Number" class="form-check">
        <label class="form-check-label">
          <input
            v-model="item.Selected"
            type="checkbox"
            :name="'select-' + item.Channel.Number"
            class="form-check-input"
          />
          {{item.Channel.Name}}
          <router-link
            :to="{name:'masterdetailselected', params:{chcode: item.Channel.Number}}"
          >{{item.Channel.Number}}</router-link>
        </label>
      </div>

      <br />

      <div>
        Selected:
        <p>
          <span v-for="(item, idx) in Selected" :key="item.Channel.Number">
            <span v-if="idx != 0">, {{""}}</span>
            <router-link
              :to="{name:'masterdetailselected', params:{chcode: item.Channel.Number}}"
            >{{item.Channel.Name}}</router-link>
          </span>
        </p>
      </div>

      <div>
        <a href="#/" class="btn btn-secondary">Cancel</a>
        <button @click="Delete" type="button" class="btn btn-danger">Delete</button>
        <button type="submit" class="btn btn-primary">S a v e</button>
      </div>
    </form>
  </div>
</template>

<script>
import API from "../apis/firstmedia.js";

export default {
  props: {
    favSetID: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      FavSet: {},
      IsNew: false,
      Selections: []
    };
  },
  created() {
    this.loadData();
  },
  watch: {
    favSetID: "loadData"
  },
  computed: {
    Selected() {
      let selected = this.Selections.filter(selection => selection.Selected);
      return selected;
    }
  },
  methods: {
    SelectAll() {
      this.Selections.forEach(selection => {
        selection.Selected = true;
      });
    },
    DeselectAll() {
      this.Selections.forEach(selection => {
        selection.Selected = false;
      });
    },
    Update() {
      let selected = this.Selected.map(s => s.Channel);

      if (selected.length > 20) {
        throw "Maximum number of channels should be 20 or less";
      }

      this.FavSet.Channels = selected;

      let allSettings = this.$store.state.settings.settings;

      if (this.IsNew) {
        allSettings.FavSets.push(this.FavSet);
        allSettings.SelectedSet = allSettings.FavSets.indexOf(this.FavSet);
      } else {
        allSettings.FavSets[this.favSetID] = this.FavSet;
        allSettings.SelectedSet = this.favSetID;
      }

      this.$store.dispatch("settings/updateAll", allSettings);

      this.$router.go(-1);
    },
    Delete() {
      if (this.IsNew) {
        this.$router.go(-1);
        return;
      }

      if (this.$store.state.settings.settings.FavSets.length < 2) {
        throw "Cannot delete the last favorite set";
      }

      let allSettings = this.$store.state.settings.settings;
      allSettings.FavSets.splice(this.favSetID, 1);

      if (allSettings.SelectedSet > allSettings.FavSets.length - 1) {
        allSettings.SelectedSet = 0;
      }

      this.$store.dispatch("settings/updateAll", allSettings);

      this.$router.push({ name: "newspaper" });
    },
    loadData() {
      let unmodified = this.$store.state.settings.settings.FavSets[
        this.favSetID
      ];
      this.IsNew = !unmodified;
      if (this.IsNew) {
        this.FavSet = {
          Description: "",
          Channels: []
        };
      } else {
        this.FavSet = unmodified;
      }

      let self = this;
      self.$store.dispatch("spinner/needSpinner").then(token => {
        return API.getChannel().then(response => {
          self.Selections = response.Channels.map(c => {
            let selected = self.FavSet.Channels.map(ch => ch.Number).includes(
              c.Number
            );
            return { Channel: c, Selected: selected };
          });
          self.$store.dispatch("spinner/dontNeedSpinner", token);
        });
      });
    }
  }
};
</script>